export default {
  apiserver: "https://oldserver.abilar.ir/app",
  fileserver: "https://oldserver.abilar.ir/uploads",
  shareserver: "https://oldserver.abilar.ir/uploads/share",
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

//  apiserver: "http://localhost:1401/app",
//    server: "http://localhost:1401/",
};
